/* eslint-disable vue/no-unused-components */
<template>
  <div>
    <headerCustom></headerCustom>
    <div class="template main-content sidenav-part ng-scope">
      <!-- <div id="progressBar">
    <div class="loader"></div>
      </div>-->
      <div>
        <div class="heading-sec">
          <div class="row">
            <div class="col-md-4 column">
              <div class="heading-profile">
                <h3>Testimonials</h3>
              </div>
            </div>
          </div>
        </div>
        <!-- Top Bar Chart -->
        <div class="panel-content">
          <div class="row">
            <div class="col-md-12">
              <div class="widget">
                <div class="table-area">
                  <div class="widget-title">
                    <div class="float-right">
                      <!-- create router link -->
                      <!-- <router-link to="CreateUser" class="btn btn-success
                      btn-small">Create</router-link>-->
                    </div>
                    <div class="d-flex">
                      <div>
                        <h6>
                          List of Testimonials
                          <span class="tableTotal">(Total : {{ totalCount }})</span>
                        </h6>
                      </div>
                      <div class="ml-auto">
                        <form class="search-form mr-form">
                          <input
                            type="text "
                            class="form-control"
                            v-model="searchText"
                            @input="viewTestimonialsList(1)"
                            placeholder="Search Here..."
                          />
                        </form>
                      </div>
                      <div>
                        <router-link to="/testimonials" append>
                          <b-button class="createBtn" variant="success">Create</b-button>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Sr.No.</th>

                          <th>Name</th>
                          <th>Date</th>
                          <th colspan="2">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(testimonial, index) in testimonials"
                          v-bind:key="testimonial._id"
                        >
                          <td>{{ index + 1 }}</td>

                          <td>
                            <div>{{ testimonial.name }}</div>
                          </td>
                          <td>
                            <div>{{ testimonial.createdAt | moment("DD/MM/YYYY") }}</div>
                          </td>
                          <!-- v-repeat -->

                          <td>
                            <div class="d-flex">
                              <div class="ml-2 cursor-pointer">
                                <router-link
                                  class="btn btn-primary mr-2"
                                  :to="{ name: 'editTestimonial', params: { id: testimonial._id } }"
                                  append
                                >
                                  <!-- <font-awesome-icon :icon="['fas', 'edit']" /> -->
                                  <b-icon-pencil></b-icon-pencil>
                                </router-link>
                              </div>
                              <!-- <div class="ml-2">
                                <deletemodal :mymodal="user"></deletemodal>
                              </div>-->
                              <div class="deletedModal">
                                <b-button
                                  variant="danger"
                                  v-b-modal.delete-modal
                                  @click="deleteTestimonialById(testimonial)"
                                >
                                  <b-icon-trash></b-icon-trash>
                                </b-button>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <div>
                          <deletemodal
                            :mymodal="testimonialData"
                            v-on:conformModal="deleteTestimonial"
                          ></deletemodal>
                        </div>
                        <!-- end v-repeat -->
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="table-body-contents text-center m-3 font-size-md font-weight-bold text-muted"
                    v-if="testimonials.length === 0"
                  >
                    No Data Found
                  </div>
                  <div class="text-center" v-if="testimonials.length >= 1">
                    <b-pagination
                      class="mb-0 float-right"
                      v-model="page"
                      align="center"
                      :total-rows="totalCount"
                      :per-page="formData.limit"
                      @input="viewTestimonialsList(page)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerCustom from "@/components/Header.vue";
import service from "@/service/apiservice";
import deletemodal from "@/components/deletemodal.vue";
import moment from "moment";

export default {
  components: {
    headerCustom,
    deletemodal
  },
  data() {
    return {
      id: "",
      logs: {
        idToDelete: ""
      },
      currentPage: 1,
      searchText: "",
      testimonials: [],
      page: 1,
      formData: { limit: 10 },
      totalCount: 0,
      perPage: 10,
      errors: [],
      data: "",
      email: "",
      testimonialData: {}
    };
  },
  methods: {
    viewTestimonialsList(pageNo) {
      this.testimonials = [];
      this.formData.page = pageNo;
      this.formData.limit = this.perPage;
      this.formData.search = this.searchText;
      service.viewTestimonials(this.formData, data => {
        if (data.status === 200) {
          this.testimonials = data.data.result;

          this.totalCount = data.data.count;
        } else {
        }
      });
    },
    deleteTestimonialById(testimonial) {
      this.testimonialData = testimonial;
    },
    deleteTestimonial(testimonial) {
      service.deleteTestimonial(testimonial._id, result => {
        if (result.status == 200) {
          this.$toaster.success("Testimonial Deleted");
          this.viewTestimonialsList(1);
        } else {
          this.$toaster.errors("Something went wrong");
        }
      });
    }
  },
  created() {
    this.viewTestimonialsList(this.page);
  }
};
</script>

<style></style>
